<template>
<div>
  <breadcrumb :crumbs="crumbs"></breadcrumb>
  <form class="ls-form" @submit.prevent="validateBeforeSubmit" v-if="!formSubmitted">
    <div class="row">
      <div class="col-md-4">
        <h3 class="ls-title-4">{{ $t('plans.new.apresentation') }}</h3>
        <p>{{ $t('plans.new.apresentation_information') }}</p>
      </div>
      <div class="col-md-8">
        <div class="row">
          <label class="ls-label col-md-12">
            <input
              class="ls-float-left select-plan"
              name="plan.suggested"
              type="checkbox"
              v-model="plan.suggested" />
            <p>
              <span class="txt-check">{{ $t('plans.new.recomended_plan') }}</span>
              <popover :position="'right'">
                <div slot="content">{{ $t('plans.new.popover.suggested') }}</div>
              </popover>
            </p>
          </label>
        </div>

        <div class="row">
          <label class="ls-label col-md-12" :class="{'ls-error': errors.has($t('plans.attributes.name')) }">
            <span class="ls-label-text">{{ $t('plans.new.name') }}</span>
            <input
              name="plan.name"
              type="text"
              maxlength="50"
              v-model="plan.name"
              v-validate="'required'"
              :placeholder="$t('plans.new.placeholder.start')"
              :name="$t('plans.attributes.name')">
            <small class="ls-help-message" v-show="errors.has($t('plans.attributes.name'))">{{ errors.first($t('plans.attributes.name')) }}</small>
            <char-counter v-show="!errors.has($t('plans.attributes.name'))" v-model="plan.name" :max="50"></char-counter>
          </label>
        </div>

        <div class="row">
          <label class="ls-label col-md-12" :class="{'ls-error': errors.has($t('plans.attributes.description')) }">
            <span class="ls-label-text">{{ $t('plans.new.description') }}</span>
            <textarea
              name="plan.description"
              rows="6"
              maxlength="256"
              v-model="plan.description"
              v-validate="'required'"
              :name="$t('plans.attributes.description')">
            </textarea>
            <small class="ls-help-message" v-show="errors.has($t('plans.attributes.description'))">{{ errors.first($t('plans.attributes.description')) }}</small>
            <char-counter v-show="!errors.has($t('plans.attributes.description'))" v-model="plan.description" :max="256"></char-counter>
          </label>
        </div>

        <div class="row">
          <label class="ls-label col-md-12" :class="{'ls-error': errors.has($t('plans.attributes.code')) }">
            <span class="ls-label-text">{{ $t('plans.new.code') }}</span>
            <input
              name="plan.code"
              type="text"
              maxlength="100"
              v-model="plan.code"
              v-validate="'required'"
              :name="$t('plans.attributes.code')">
            <small class="ls-help-message" v-show="errors.has($t('plans.attributes.code'))">{{ errors.first($t('plans.attributes.code')) }}</small>
            <char-counter v-show="!errors.has($t('plans.attributes.code'))" v-model="plan.code" :max="100"></char-counter>
          </label>
        </div>
      </div>
    </div>

    <div class="ls-clearfix ls-md-margin-bottom"></div>

    <div class="row">
      <div class="col-md-4">
        <h3 class="ls-title-4">{{ $t('plans.new.value_and_periodicity') }}</h3>
        <p>{{ $t('plans.new.deadline_message') }}</p>
      </div>

      <div class="col-md-8">
        <div class="row">
          <label class="ls-label col-md-12" :class="{'ls-error': errors.has($t('plans.attributes.periodicity')) }">
           <span class="ls-label-text">{{ $t('plans.attributes.periodicity') }}
              <popover :position="'right'">
                <div slot="content">{{ $t('plans.new.popover.periodicity') }}</div>
              </popover>
            </span>
            <div class="col-md-2 ls-no-padding">
              <input
                type="number"
                min="0"
                step="1"
                name="plan.periodicity"
                v-model="plan.periodicity"
                v-validate="'required|decimal:0'"
                :name="$t('plans.attributes.periodicity')">
            </div>
            <small class="ls-help-message" v-show="errors.has($t('plans.attributes.periodicity'))">{{ errors.first($t('plans.attributes.periodicity')) }}</small>
          </label>
        </div>
        <div class="row">
          <label class="ls-label col-md-12">
            <span class="ls-label-text">{{ $t('plans.new.period_plan') }}
              <popover :position="'right'">
                <div slot="content">{{ $t('plans.new.popover.duration') }}</div>
              </popover>
            </span>
            <p>Ilimitado</p>
          </label>
        </div>
        <div class="row">
          <label class="ls-label col-md-6" :class="{'ls-error': errors.has($t('plans.attributes.price')) }">
            <b class="ls-label-text">{{ $t('plans.new.value') }}</b>
            <money-input
              v-model="plan.price"
              :value="plan.price"
              @updateValue="(value) => { plan.price = value }"
              v-validate="'required'"
              :name="$t('plans.attributes.price')">
            </money-input>
            <small class="ls-help-message" v-show="errors.has($t('plans.attributes.price'))">{{ errors.first($t('plans.attributes.price')) }}</small>
          </label>
        </div>
      </div>

      <div class="ls-clearfix"></div>
      <div class="row">
        <div class="col-md-12">
          <div class="ls-actions-btn">
            <div class="ls-float-right">
              <router-link :to="{ name: 'plans'}" class="ls-btn" :title="$t('application.button.cancel')">{{ $t('application.button.cancel') }}</router-link>
              <button type="submit" class="ls-btn-primary">{{ $t('application.button.include_plan') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </form>
</div>
</template>
<script>
  import { mapActions } from 'vuex'
  import Breadcrumb from 'src/app/components/shareds/Breadcrumb'
  import MoneyInput from 'src/app/components/shareds/money-input/MoneyInput'
  import Popover from 'src/app/components/shareds/popover/Popover'
  import CharCounter from 'src/app/components/shareds/char-counter/CharCounter'

  export default {
    name: 'NewPlan',
    components: { Breadcrumb, MoneyInput, Popover, CharCounter },
    data () {
      return {
        formSubmitted: false,
        plan: {
          suggested: false,
          name: '',
          code: '',
          description: '',
          price: '',
          periodicity: '1',
          active: true
        },
        crumbs: {
          'ico': 'ls-ico-docs',
          'section': this.$t('plans.new.new_plan'),
          'paths': {
            0: {
              'title': this.$t('plans.main.title'),
              'path': '/plans'
            }
          }
        }
      }
    },
    methods: {
      ...mapActions(['createPlan']),
      newPlan (params) {
        this.createPlan(this.$route.params)
      },
      validateBeforeSubmit () {
        this.$validator.validateAll().then(success => {
          if (!success) {
            return
          }
          this.submitForm()
        })
      },
      submitForm () {
        this.formSubmitted = true
        this.createPlan(this.plan).then(this.afterCreate)
      },
      afterCreate () {
        this.$router.push('/plans')
      }
    }
  }
</script>
<style lang="scss">
  .txt-check {
    margin: 0 0 0 6px;
    display: inline-block;
  }
  .ls-help-inline + .ls-help-message {
    position: relative;
  }
  .select-plan {
    margin-top: 3px;
  }
  .ls-label .ls-label-text + p {
    font-size: 13px;
  }
  .ls-label .ls-label-text {
    font-size: 13px;
  }
</style>



// WEBPACK FOOTER //
// New.vue?c0e38ad6